import { Shipment } from './../components/shipment/shipment.reducer';
import { ProcessType } from './../components/process-types/process-types.reducer';
import { Location } from './../components/location/location.reducer';
import _ from 'lodash';
import { combineReducers } from 'redux';
import { Inventory } from '../components/inventory/invetory.reducer';
import { Destination } from '../components/destination/destination.reducer';
import { Auth } from '../components/auth/auth.reducer';
import { Product } from '../components/product/product.reducer';
import { Customer } from '../components/customer/customer.reducer';
import { Order } from '../components/order/order.reducer';
import { Category } from '../components/category/category.reducer';
import { Size } from '../components/size/size.reducer';
import { Designer } from './../components/designer/designer.reducer';
import { Style } from './../components/style/style.reducer';
import { Status } from './../components/status/status.reducer';
import { Condition } from './../components/condition/condition.reducer';
import { Collection } from './../components/collection/collection.reducer';
import { ProcessStatus } from './../components/process-status/process-status.reducer';
import { ProcessTransition } from './../components/process-transition/process-transition.reducer';
import { Currency } from './../components/currency/currency.reducer';
import { Courier } from './../components/courier/courier.reducer';
import { Acl } from './../components/acl/acl.reducer';
import { Users } from './../components/user/user.reducer';
import { Constant } from './constant/constant.reducer';
import { environment } from '../../environments/environment';
import { Provider } from './../components/provider/provider.reducer';
import { Print } from './print/print.reducer';
import { Download } from './download/download.reducer';
import { Color } from './../components/color/color.reducer';
import { Wardrobe } from './../components/wardrobe/wardrobe.reducer';
import { Delivery } from './../components/delivery/delivery.reducer';
import { Payment } from './../components/payment/payment.reducer';
import { Coupon } from './../components/coupon/coupon.reducer';
import { Cartrule } from './../components/cartrule/cartrule.reducer';
import { ProcessStatusGroup } from './../components/process-status-group/process-status-group.reducer';
import { CustomAttribute } from './../components/custom-attribute/custom-attribute.reducer';
import { CustomAttributeOption } from './../components/custom-attribute-option/custom-attribute-option.reducer';
import { SETUP_CURRENCY_SUCCEEDED } from './action';
const RootReducer = (
  state = {
    config: environment,
    attributes: {
      currency: {
        fetched: false,
        items: [],
        selected: null
      }
    }
  },
  action
) => {
  switch (action.type) {
    case SETUP_CURRENCY_SUCCEEDED:
      return _.assign({}, state, {
        attributes: _.assign({}, state.attributes, {
          currency: {
            fetched: true,
            items: action.data.currencies,
            selected: action.data.selected_currency,
            country: action.data.country
          }
        })
      });
    default:
      return state;
  }
};

export default combineReducers({
  RootReducer,
  CustomAttributeOption,
  CustomAttribute,
  ProcessStatusGroup,
  Cartrule,
  Coupon,
  Wardrobe,
  Shipment,
  Color,
  Inventory,
  Location,
  Destination,
  Auth,
  Product,
  Customer,
  Order,
  Size,
  Designer,
  Category,
  Style,
  Status,
  Condition,
  Collection,
  ProcessType,
  ProcessStatus,
  ProcessTransition,
  Acl,
  Users,
  Constant,
  Provider,
  Print,
  Download,
  Currency,
  Courier,
  Delivery,
  Payment
});
